import React, { useRef } from "react";
import Superior from "../Assets/Images/Superior.svg";
import Optima from "../Assets/Images/Optima.svg";
import Vital from "../Assets/Images/Vital.svg";
import Insta from "../Assets/Images/insta.svg";
import linkedin from "../Assets/Images/linkedin.svg";
import { Link } from "react-router-dom";
import { useTranslation } from "../Hooks/useTranslation";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const translations = useTranslation();
  const location = useLocation();

  // Pages that have FAQ sections
  const pagesWithFAQs = [
    "/",
    "/universal-life-insurance",
    "/term-life-insurance",
    "/indexed-universal-life-insurance",
    "/hospitals",
    "/compare",
  ];

  // Check if current page has FAQ section
  const currentPageHasFAQs = pagesWithFAQs.includes(location.pathname);

  // Determine FAQ link - if current page has FAQs, link to current page's FAQ section, otherwise go to home page FAQ
  const faqLink = currentPageHasFAQs
    ? location.pathname === "/"
      ? "/?section=faqs"
      : `${location.pathname}?section=faqs`
    : "/?section=faqs"; // If current page doesn't have FAQs, always go to home

  return (
    <div className="mainfooterdiv bg-[#FAFAFA]" id="footer">
      <div className="container">
        <div className="mx-auto pt-0">
          <div className="flex flex-col lg:flex-row justify-between gap-4 xl:gap-8 bg-[#F7F6F2] rounded-[22px] px-6 xl:px-12 lg:py-24 py-12 relative Myriad-font">
            <div className="footer_last_column lg:order-last w-full lg:w-1/5 text-left border-b border-solid border-[#187C85] lg:border-b-0 pb-2 lg:p-0 lg:mb-0 mb-6">
              <h3 className="flex justify-between align-center text-[16px] lg:text-[18px] font-semibold mb-4 lg:mb-8 lg:pr-0 pr-[3.5rem]">
                <div className="">{translations.footer.navLinks.ContactUs}</div>
                <div className=" mb-0 items-center lg:hidden lg:hidden flex lg:justify-start space-x-2 lg:relative lg:top-auto lg:right-auto">
                  {/* <img src={Insta} alt="Instagram" className="w-6 h-6" /> */}
                  <Link
                    to="https://www.linkedin.com/company/american-fidelity-international-bermuda-ltd"
                    target="_blank"
                  >
                    <img src={linkedin} alt="LinkedIn" className="w-6 h-6" />
                  </Link>
                </div>
              </h3>
              <p className="text-[12px] lg:text-sm text-[#565454] mb-2 lg:mb-4">
                {translations.footer.address}
              </p>

              <p className="text-[12px] lg:text-sm text-[#565454] mb-2 lg:mb-4">
                {translations.footer.number}
              </p>
              <p className="text-[12px] lg:text-sm text-[#565454] mb-2 lg:mb-4">
                Email: <br className="hidden md:block" />
                {translations.footer.email}
              </p>

              <p className="text-[12px] lg:text-sm text-[#565454] mb-2 lg:mb-4">
                {translations.footer.fax}
              </p>

              <div className="hidden lg:flex justify-center lg:justify-start mt-2 space-x-2 lg:relative lg:top-auto lg:right-auto">
                {/* <img src={Insta} alt="Instagram" className="w-6 h-6" /> */}
                <Link
                  to="https://www.linkedin.com/company/american-fidelity-international-bermuda-ltd"
                  target="_blank"
                >
                  <img src={linkedin} alt="LinkedIn" className="w-6 h-6" />
                </Link>
              </div>
            </div>

            <div className="flex flex-wrap justify-between w-full lg:w-4/5 footer-menu-column">
              <div className="w-1/2 lg:w-1/6 lg:max-w-[70px]">
                <Link to="/">
                  <h4 className="text-[16px] lg:text-lg font-semibold mb-4 lg:mb-8 ">
                    {translations.footer.navLinks.Home}
                  </h4>
                </Link>
                <ul className="leading-none lg:leading-normal text-[12px] lg:text-sm mb-12 lg:mb-0">
                  <Link to="/?section=About-Us">
                    <li className="lg:mb-4 mb-2 lg:leading-[22px] leading-[19px] text-[#565454]">
                      {translations.footer.navLinks.About_Us}
                    </li>
                  </Link>
                  <Link to="/?section=our-products">
                    <li className="lg:mb-4 mb-2 lg:leading-[22px] leading-[19px] text-[#565454]">
                      {translations.footer.navLinks.Products}
                    </li>
                  </Link>
                  <Link to={faqLink}>
                    <li className="lg:mb-4 mb-2 lg:leading-[22px] leading-[19px] text-[#565454]">
                      {translations.footer.navLinks.FAQs}
                    </li>
                  </Link>
                </ul>
              </div>

              <div className="w-1/2 lg:w-1/6 lg:max-w-[102px]">
                <Link to="/about">
                  <h4 className="text-[16px] lg:text-lg font-semibold mb-4 lg:mb-8">
                    {translations.footer.navLinks.About_Us}
                  </h4>
                </Link>
                <ul className="leading-none lg:leading-normal text-[12px] lg:text-sm mb-12 lg:mb-0">
                  <Link to="/about?section=american-fidelity">
                    <li className="lg:mb-4 mb-2 lg:leading-[22px] leading-[19px] text-[#565454]">
                      {translations.footer.navLinks.American_Fidelity}
                    </li>
                  </Link>
                  <Link to="/about?section=values-guide-us">
                    <li className="lg:mb-4 mb-2 lg:leading-[22px] leading-[19px] text-[#565454]">
                      {translations.footer.navLinks.Learn_More}
                    </li>
                  </Link>
                  <Link to="/about?section=about-international-client-id">
                    <li className="lg:mb-4 mb-2 lg:leading-[22px] leading-[19px] text-[#565454]">
                      {translations.footer.navLinks.AFIBL}
                    </li>
                  </Link>
                </ul>
              </div>

              <div className="w-1/2 lg:w-1/5">
                <div className="flex flex-col lg:flex-row items-start lg:items-center lg:gap-2 gap-4 mb-4 lg:mb-8">
                  <img
                    src={Superior}
                    alt="Superior Plan"
                    width={20}
                    height={17}
                  />
                  <Link to="/universal-life-insurance">
                    <h4 className="text-[16px] lg:text-[18px] font-semibold leading-normal">
                      {translations.footer.navLinks.Universal_Life}
                    </h4>
                  </Link>
                </div>
                <ul className="leading-none lg:leading-normal text-[12px] lg:text-sm mb-12 lg:mb-0 lg:pl-7">
                  <Link to="/universal-life-insurance?section=Benefits">
                    <li className="lg:mb-4 mb-2 lg:leading-[22px] leading-[19px] text-[#565454]">
                      {translations.footer.navLinks.Benefits}
                    </li>
                  </Link>
                  <Link to="/universal-life-insurance?section=how-it-works">
                    <li className="lg:mb-4 mb-2 lg:leading-[22px] leading-[19px] text-[#565454]">
                      {translations.footer.navLinks.How_It_Works}
                    </li>
                  </Link>
                  <Link to="/universal-life-insurance?section=Universal-types">
                    <li className="lg:mb-4 mb-2 lg:leading-[22px] leading-[19px] text-[#565454]">
                      {translations.footer.navLinks.Universal_Life}
                    </li>
                  </Link>
                  <Link to="/indexed-universal-life-insurance">
                    <li className="lg:mb-4 mb-2 lg:leading-[22px] leading-[19px] text-[#565454]">
                      {translations.footer.navLinks.Indexed_Universal_Life}
                    </li>
                  </Link>
                </ul>
              </div>

              <div className="w-1/2 lg:w-1/6">
                <div className="flex flex-col lg:flex-row items-start lg:items-center lg:gap-2 gap-4 mb-4 lg:mb-8">
                  <img
                    src={Optima}
                    alt="Optima Plan"
                    width={20}
                    height={17}
                    className="lg:h-[auto] h-[24px]"
                  />
                  <Link to="/term-life-insurance">
                    <h4 className="text-[16px] lg:text-[18px] font-semibold leading-normal">
                      {translations.footer.navLinks.Select_Term}
                    </h4>
                  </Link>
                </div>
                <ul className="leading-none lg:leading-normal text-[12px] lg:text-sm mb-12 lg:mb-0 lg:pl-7">
                  <Link to="/term-life-insurance?section=terms-benefits">
                    <li className="lg:mb-4 mb-2 lg:leading-[22px] leading-[19px] text-[#565454]">
                      {translations.footer.navLinks.Benefits}
                    </li>
                  </Link>
                  <Link to="/term-life-insurance?section=improve-benefits">
                    <li className="lg:mb-4 mb-2 lg:leading-[22px] leading-[19px] text-[#565454]">
                      {translations.footer.navLinks.AdditionalBenefits}
                    </li>
                  </Link>
                  <Link to="/term-life-insurance?section=types-of-coverage">
                    <li className="lg:mb-4 mb-2 lg:leading-[22px] leading-[19px] text-[#565454]">
                      {translations.footer.navLinks.CoverageType}
                    </li>
                  </Link>
                </ul>
              </div>

              <div className="w-1/2 lg:w-1/5 max-w-[170px]">
                <div className="flex flex-col lg:flex-row items-start lg:items-center lg:gap-2 gap-4 mb-4 lg:mb-8">
                  <img
                    src={Vital}
                    alt="Vital Plan"
                    width={20}
                    height={17}
                    className="lg:h-[auto] h-[24px]"
                  />
                  <Link to="/critical-illness-insurance">
                    <h4 className="text-[16px] lg:text-[18px] font-semibold leading-normal">
                      {translations.footer.navLinks.Critical_Illness}
                    </h4>
                  </Link>
                </div>
                <ul className="leading-none lg:leading-normal text-[12px] lg:text-sm mb-8 lg:mb-0 lg:pl-7">
                  <Link to="/critical-illness-insurance?section=WhyChooseIllness">
                    <li className="lg:mb-4 mb-2 lg:leading-[22px] leading-[19px] text-[#565454]">
                      {translations.footer.navLinks.Benefits}
                    </li>
                  </Link>
                  <Link to="/critical-illness-insurance?section=critical-illness-covered">
                    <li className="lg:mb-4 mb-2 lg:leading-[22px] leading-[19px] text-[#565454]">
                      {translations.footer.navLinks.Critical_Illness}
                    </li>
                  </Link>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
